import React from 'react';

interface CreateFormSectionProps {
  title: string;
  /** What the group is for, and what it costs to leave it wrong. */
  description: string;
  children: React.ReactNode;
}

/**
 * One group of fields on the create form.
 *
 * The create form is a single page rather than the seven tabs the edit form
 * uses. Four fields are needed to create a distributor at all and they lived on
 * two different tabs, past four tabs that cannot do anything until the
 * distributor exists, so the required fields were the hardest things on the
 * screen to find.
 */
export const CreateFormSection: React.FC<CreateFormSectionProps> = ({
  title,
  description,
  children,
}) => (
  <section className="space-y-5 border-b border-divider p-6 last:border-b-0">
    <div className="space-y-1">
      <h3 className="text-medium font-semibold text-foreground">{title}</h3>
      <p className="text-small text-default-600">{description}</p>
    </div>
    {children}
  </section>
);
